import { useEffect, useState } from "react";

import {
  useWindowSize,
  useWindowWidth,
  useWindowHeight,
} from '@react-hook/window-size'

const useSize = () => {
  const [windowSize, setWindowSize] = useState([
    useWindowHeight(),
    useWindowWidth(),
  ]);


  const [width, height] = useWindowSize()
  

  useEffect(() => {
    setWindowSize([width,height]);
  }, []);

  return windowSize;
};

export default useSize;
